export default __webpack_public_path__ + "static/media/orders-table-accept.a965881c.svg";